import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';
import { useUser } from '../../context/UserContext';

export interface TeamUser {
  id: string;
  name: string;
  email: string;
  avatar: string | null;
  role: string | null;
}

export function useTeamUsers() {
  const { user } = useUser();
  const [users, setUsers] = useState<TeamUser[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.agency_id) {
      setLoading(false);
      return;
    }

    const fetchUsers = async () => {
      const { data, error } = await supabase
        .from('users')
        .select('id, name, email, avatar, role')
        .eq('agency_id', user.agency_id!)
        .neq('id', user.id)
        .order('name');

      if (!error && data) {
        setUsers(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          data.map((u: any) => ({
            id: u.id,
            name: u.name || u.email?.split('@')[0] || 'Unknown',
            email: u.email,
            avatar: u.avatar || null,
            role: u.role || null,
          }))
        );
      }
      setLoading(false);
    };

    fetchUsers();
  }, [user]);

  return { users, loading };
}
